import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prInvert',
    standalone: false
})
export class PrReversePipe implements PipeTransform {
  transform(value) {
    return value.slice().reverse();
  }
}
